import { PrimaryColors } from '@/common/theme/constants';
import { SxProps } from '@mui/material';

export const styledReceiptAccordionChildrenWrapper: SxProps = {
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
};

export const styledSectionTitle: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  pr: '11px',
  color: PrimaryColors.black,
  textTransform: 'uppercase',
};

export const styledAdditionalTotalText: SxProps = {
  opacity: '40%',
  alignSelf: 'flex-end',
};

export const styledTitlePrices: SxProps = {
  display: 'flex',
  gap: '0.5rem',
};
